import React, { useContext } from "react";
import ArrowIcon from "../../icons/arrow-icon";
import DoubleArrowIcon from "../../icons/double-arrow-icon";

import { YearContext } from "../../contexts/yearContext";

const Pagination = ({ data, gotoPage, forceEntryYear = true }) => {
  const { entryYear } = useContext(YearContext);

  const handlePage = (op) => {
    let { totalPages, page } = data;

    if (op === "+" && page <= totalPages) {
      gotoPage(forceEntryYear ? {page: page + 1, entry_year_id: entryYear} : {page: page + 1});
    }

    if (op === "-" && page != 1) {
      gotoPage(forceEntryYear ? {page: page - 1, entry_year_id: entryYear} : {page: page - 1});
    }
  };

  const currentPageNum = (i) => {
    return data.page === i ? "active" : "";
  };

  const renderPageNums = () => {
    let PageBtns = [];

    for (let i = data.page; i <= data.page + 4; i++) {
      if (i <= data.totalPages) {
        PageBtns.push(
          <button
            onClick={() => gotoPage(forceEntryYear ? {page: i, entry_year_id: entryYear} : {page: i})}
            className={currentPageNum(i)}
            key={i}
          >
            {i}
          </button>
        );
      }
    }

    return PageBtns;
  };

  return (
    <div className="pagination-container no-select">
      <button
        className="right-arrow"
        onClick={() => gotoPage(forceEntryYear ? {entry_year_id: entryYear} : {})}
      >
        <DoubleArrowIcon />
      </button>
      <button className="right-arrow" onClick={() => handlePage("-")}>
        <ArrowIcon />
      </button>
      {renderPageNums()}
      <button className="left-arrow" onClick={() => handlePage("+")}>
        <ArrowIcon />
      </button>
      <button
        className="left-arrow"
        onClick={() =>
          gotoPage(forceEntryYear ? {page: data.totalPages, entry_year_id: entryYear} : {page: data.totalPages})
        }
      >
        <DoubleArrowIcon />
      </button>
    </div>
  );
};

export default Pagination;
